(function () {
  const root = document.querySelector('[data-meroo-bestsellers]');
  if (!root) return;

  const dialog = root.querySelector('dialog.meroo-qv');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const imageEl = dialog.querySelector('.meroo-qv__image');
  const titleEl = dialog.querySelector('.meroo-qv__title');
  const priceEl = dialog.querySelector('.meroo-qv__price');
  const shadeEl = dialog.querySelector('.meroo-qv__shade');
  const variantInput = dialog.querySelector('[data-meroo-qv-variant]');
  const atcBtn = dialog.querySelector('[data-meroo-qv-atc]');
  const atcLabel = atcBtn.querySelector('[data-meroo-qv-label]');
  const detailsLink = dialog.querySelector('[data-meroo-qv-details]');
  const productForm = dialog.querySelector('product-form');
  const quantityInput = productForm.querySelector('[name="quantity"]');
  const inlineQuantity = productForm.querySelector('.meroo-inline-qty');

  const openQuickView = (card) => {
    if (!card || productForm.inlineBusy) return;

    titleEl.textContent = card.dataset.productTitle || '';
    const compare = card.dataset.productCompare;
    if (compare) {
      priceEl.innerHTML =
        '<span>' +
        (card.dataset.productPrice || '') +
        '</span> <s class="meroo-pcard__price-compare">' +
        compare +
        '</s>';
    } else {
      priceEl.textContent = card.dataset.productPrice || '';
    }

    if (card.dataset.productShade) {
      shadeEl.hidden = false;
      shadeEl.textContent = card.dataset.productShade;
    } else {
      shadeEl.hidden = true;
      shadeEl.textContent = '';
    }

    variantInput.value = card.dataset.variantId || '';
    const cardQuantity = card.querySelector('[name="quantity"]');
    quantityInput.value = cardQuantity?.value || '1';
    quantityInput.dataset.min = cardQuantity?.dataset.min || '1';
    quantityInput.dataset.step = cardQuantity?.dataset.step || '1';
    quantityInput.dataset.max = cardQuantity?.dataset.max || '';
    detailsLink.href = card.dataset.productUrl || '#';

    if (card.dataset.image) {
      imageEl.hidden = false;
      imageEl.src = card.dataset.image;
      imageEl.alt = card.dataset.productTitle || '';
    } else {
      imageEl.hidden = true;
      imageEl.removeAttribute('src');
    }

    const available = card.dataset.available === 'true';
    atcBtn.disabled = !available;
    atcLabel.textContent = available ? 'Add to cart' : 'See other shades';
    productForm.handleErrorMessage();
    productForm.querySelector('.meroo-morph-button-wrapper').classList.remove('is-added');
    inlineQuantity.hidden = true;
    inlineQuantity.classList.add('hidden');
    inlineQuantity.setAttribute('aria-label', `Quantity in your bag for ${card.dataset.productTitle || 'this shade'}`);
    productForm.syncButtonWithCart();

    dialog.showModal();
  };

  const closeQuickView = () => {
    if (dialog.open) dialog.close();
  };

  root.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-meroo-quick-view]');
    if (!trigger || !root.contains(trigger)) return;
    event.preventDefault();
    openQuickView(trigger.closest('.meroo-pcard'));
  });

  dialog.querySelectorAll('[data-meroo-qv-close]').forEach((btn) => {
    btn.addEventListener('click', closeQuickView);
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeQuickView();
  });

})();
